import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicCreditCard({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M13 2.25c.97 0 1.75.78 1.75 1.75v8c0 .97-.78 1.75-1.75 1.75H3c-.97 0-1.75-.78-1.75-1.75V4c0-.97.78-1.75 1.75-1.75zm.25 5.5H2.75V12c0 .12.08.22.2.24l.05.01h10c.14 0 .25-.11.25-.25V7.75zm-.25-4H3a.25.25 0 00-.25.25v1.25h10.5V4a.25.25 0 00-.2-.24L13 3.75zm-5 5.5a.75.75 0 01.1 1.5H5a.75.75 0 01-.1-1.5H8z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicCreditCard.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicCreditCard.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicCreditCard svgRef={ref} {...props} />);
export default ForwardRef;
